
export const USER_API = 'https://dummyapi.io/user';
export const DATA_API = 'https://dummyapi.io/data/v1';
